module.exports = __webpack_public_path__ + "static/media/2023-VC-Feature-Banner-Tablet@2x.669f0e30.jpg";